import React from "react"
import Pagination from "react-bootstrap/Pagination"
import PropTypes from "prop-types"
import ArrowIcon from "../planning/arrowIcon"

const PaginationComponent = ({ itemsCount, itemsPerPage, currentPage, alwaysShown = true, setQuery }) => {
    const pagesCount = Math.ceil(itemsCount / itemsPerPage)
    const isPaginationShown = alwaysShown ? true : pagesCount > 1
    const isCurrentPageFirst = currentPage === 1
    const isCurrentPageLast = currentPage === pagesCount

    const changePage = number => {
        if (currentPage === number) return
        setQuery({ page: number })
    }

    const onPageNumberClick = pageNumber => {
        changePage(pageNumber)
    }

    const onPreviousPageClick = () => {
        changePage(currentPage - 1)
    }

    const onNextPageClick = () => {
        changePage(currentPage + 1)
    }

    let isPageNumberOutOfRange

    const pageNumbers = [...new Array(pagesCount)].map((_, index) => {
        const pageNumber = index + 1
        const isPageNumberFirst = pageNumber === 1
        const isPageNumberLast = pageNumber === pagesCount
        const isCurrentPageWithinTwoPageNumbers = Math.abs(pageNumber - currentPage) <= 1

        if (isPageNumberFirst || isPageNumberLast || isCurrentPageWithinTwoPageNumbers) {
            isPageNumberOutOfRange = false
            return (
                <Pagination.Item key={pageNumber} onClick={() => onPageNumberClick(pageNumber)} active={pageNumber === currentPage}>
                    {pageNumber}
                </Pagination.Item>
            )
        }

        if (!isPageNumberOutOfRange) {
            isPageNumberOutOfRange = true
            return <Pagination.Ellipsis key={pageNumber} className="muted" />
        }

        return null
    })

    return (
        <>
            {isPaginationShown && (
                <Pagination>
                    <Pagination.Prev onClick={onPreviousPageClick} disabled={isCurrentPageFirst}>
                        <ArrowIcon className="arrow-prev" color={isCurrentPageFirst ? "#3D49984D" : "#3D4998"} /> Prev
                    </Pagination.Prev>
                    {pageNumbers}
                    <Pagination.Next onClick={onNextPageClick} disabled={isCurrentPageLast}>
                        Next <ArrowIcon className="arrow-next" color={isCurrentPageLast ? "#3D49984D" : "#3D4998"} />
                    </Pagination.Next>
                </Pagination>
            )}
        </>
    )
}

PaginationComponent.propTypes = {
    itemsCount: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    alwaysShown: PropTypes.bool
}

export default PaginationComponent
